import toArray from 'lodash/toArray';

const getProviderServicesList = (services, providerId) => {
    let providerServices = [];
    let servicesArray = toArray(services);
    servicesArray.map(service => {
        if (service.provider === providerId) {
            providerServices.push(service);
        };
    });
    return providerServices;
};

export default getProviderServicesList;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/utils/getProviderServicesList.js